export const config = {
  firebase: {
    apiKey: process.env.FIREBASE_API_KEY!,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN!,
    projectId: process.env.FIREBASE_PROJECT_ID!,
    appId: process.env.FIREBASE_APP_ID!,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID!,
  },
  functionsRegion: process.env.FUNCTIONS_REGION || "europe-west3",
  useEmulator: process.env.USE_EMULATOR === "true",
  recaptchaSiteKey: process.env.RECAPTCHA_SITE_KEY || "",
  appCheckDebugToken: process.env.APPCHECK_DEBUG_TOKEN || "",
  legals: {
    privacy: "/privacy",
    imprint: "/imprint",
    reportContent: "https://trust-leap.de/melden?src=reviews",
  },
};
